export default "__VITE_ASSET__Bgdnrx0i__"